<script setup lang="ts">
  import { FormInput } from '@logistiek-zonder-papier/lzp-library'
  import { computed } from 'vue'
  import type { Address } from '@/model/address.model.ts'

  const props = defineProps<{ address: Address | null }>()

  const senderStreetAndNumber = computed(() => {
    if (!props.address) return ''
    return `${props.address?.streetName} ${props.address?.houseNumber}`
  })
</script>

<template>
  <FormInput :model-value="senderStreetAndNumber" label="Straat en nummer" disabled />
  <div class="address-container">
    <FormInput :model-value="address?.postalCode" label="Postcode" disabled />
    <FormInput :model-value="address?.city" label="Gemeente" disabled />
    <FormInput :model-value="address?.countryCode" label="Land" disabled />
  </div>
</template>

<style scoped>
  .address-container {
    display: flex;
    gap: 2rem;
  }

  .address-container :first-child {
    flex: 1 0 0;
  }

  .address-container > * {
    flex: 3 0 0;
  }
</style>
